import Vue from 'vue'
import { $$ } from '../_utils'

Vue.component('vue-tax-office-select-wrapper', {
  template: '#vue-tax-office-select-wrapper-template',
  props: { items: Array, type: String },
  data() {
    return {}
  },
})

const officesSelects = $$('#vue-tax-office-select-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!officesSelects) return
  officesSelects.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
